import { UserManager } from 'oidc-client-ts';
import status, { message }  from 'statuses'; 

export   class LoopOidcCallback{
    constructor(clientId,authorityUrl,redirectUrl){
		
		var config = new LoopOidcConfig(clientId,authorityUrl,redirectUrl);
		config.response_mode = "query";
     new UserManager(config).signinRedirectCallback()
            .catch((err) => {
                console.log(err);
            })
			.then((user)=>{
				if(user.state)
				{
					console.log(user);
					window.location.replace(user.state);
				}
				else
				{
					// error
				}
			}); 

	
    }

}

export   class LoopOidcSilentCallback{
    constructor(){

		var config = new LoopOidcConfig();
		config.response_mode = "query";
		
     let mgr = new UserManager(config);
	 mgr.signinSilentCallback()
	 .catch((err) => {
		 
		 console.log(err);
	 })
	 .then((user)=>{
		 console.log(user);
	 }); 
     
    }

}




	export   class LoopOidcConfig
	{
		constructor(clientId,authorityUrl,redirectUrl)
		{

			this.client_id = null;
			this.acr_values = null;
			this.redirect_uri = null;

			if(!authorityUrl)
			{
				this.authority= this.GetAuthorityRedirectFromDiscovery();							
			}
			else
			{
				this.authority = authorityUrl;
			}

		
			this.error = null;
			
		
			this.response_type = "code";
			this.scope = "openid offline_access";
			
			var root = window.location.origin;
			if(!clientId)
				clientId = "Daymap.API";
			

			this.client_id = clientId;
			var acr = root;
			switch(clientId)
			{
				case "Daymap.API":
				case "Connect.API":
					acr = acr + "/DaymapMobile.API/"
					break;
				case "Daymap.Web":
					acr = acr + "/daymap/";
					break;
				
				case "Connect.Web":
					acr = acr + "/daymapconnect/";
					break;
				case "CheckIn.API":
					acr = acr + "/kiosk/";
					break;
				case "Daymap.Checkin":
					acr = acr + "/checkin/";
					break;
				
				default:
					acr = acr + "/daymap/";

			}

			this.acr_values = acr;

				if(!redirectUrl)	
				this.redirect_uri = root +'/lms/signin-oidc/callback.html'
			else
				this.redirect_uri  = redirectUrl;

			this.silent_redirect_uri =  this.redirect_uri.replace("callback.html","callbackSilent.html"); 
			
		}
		

		GetAuthorityRedirectFromDiscovery = function(clientid)
		{
		

			var authority = sessionStorage.getItem("IdServer");

			if(!authority)
			{
				var path = window.location.origin;

				var request = new XMLHttpRequest();
				request.open('GET', path + '/lms/daymap-discovery', false);  // `false` makes the request synchronous
				request.send(null);
				if (request.status === 200)
				{
					var json = JSON.parse(request.responseText);
					authority = json["IDServer"];
					if(!authority)
						throw new Error("Could not determine authority url from discovery endpoint response");

					sessionStorage.setItem("IdServer",authority);	
				}
				else
					throw new Error("Could not contact discovery endpoint");
			}
			else
			{
				authority = sessionStorage.getItem("IdServer");

			}

			return authority;
			
				
		}
	}
	
    export   class LoopOidc {
        constructor(loopOidcConfig, options = null) {
            this.config = loopOidcConfig;
            this.OidcManager = new UserManager(this.config);
			this.forcePrompt = options?.forcePrompt;
		
            // Events 
            this.OnSignInError = null;
			this.OnIFrameRedirect = null;
            this.OnIDServerError = null;
            this.OnUnauthorised = null;
            this.OnLoginRequired = null;
			this.OnDiscoveryEndpointError = null;
			this.Popup = document.location.href.includes("popup=1");

            this.GetAccessToken = async function (retry) {
                try {
                    
                    var u = await this.OidcManager.getUser();
                    if (!u || u.expired) {
					
						if(retry || this.forcePrompt)
							await this.OidcManager.signinRedirect({state:window.location.href, prompt: this.forcePrompt ? 'login' : null });
						else
							await this.OidcManager.signinSilent();

                        u = await this.OidcManager.getUser();
                    }
					

                    return u.access_token;
                }
                catch (err) {
					if(!retry)
					{
						if(window.frameElement !== null){
							var url;			
							if (document.location.href.includes("?")){
								url = document.location.href + "&popup=1";
							}else{
								url = document.location.href + "?popup=1";
							}
							this.OnIFrameRedirect();
							window.open(url, "Reauthenticate","'height=600,width=300'");
						}else{
							return this.GetAccessToken(true);
						}	
					}
					else
					{
						if (err.error === "login_required") {
							if (this.OnLoginRequired)
								this.OnLoginRequired();
						}
						else {
							if (this.OnIDServerError)
								this.OnIDServerError(err);
							else
								throw err;
						}
					}
				}
 
			}

            this.GetResponse = async function (url, postData, config) {
                try {
					
					if(!this.config.error)
					{
						var access_token = await this.GetAccessToken(false);

						if (!access_token)
						{
							if (this.OnSignInError)
								this.OnSignInError("No valid access token could be found");
							else
								throw Error("No valid access token could be found");

								return;
						}
						if (!config) {
							config = {
								headers: { "Content-Type": "application/json" }
							};
						}
						if (!config.headers)
							config.headers = { "Content-Type": "application/json" };

						if (postData) {
							if (!config.method)
								config.method = "POST";
							config.body = JSON.stringify(postData);
						} else if (!config.method){
							config.method = "GET";
						}

						if(this.Popup == true){
							window.opener.location.reload();
							window.close();
						}

						config.credentials = "omit";
						config.headers["Authorization"] = "Bearer " + access_token;

						let response = await fetch(url, config);
						if (!response.ok) {
							const statusText=status(response.status);
							switch(response.status){
								case "403":
									if (this.OnUnauthorised)
										this.OnUnauthorised(response); 
									throw new Error("You are not authorised to make this request");
 
								case "404": 
										if (this.OnIDServerError)
										this.OnIDServerError("ID Server is currently not responding.");
									throw new Error("ID Server is currently not responding."); 
									
								case "502":
								case "503":
								case "504":
									throw new Error("The server is currently not responding (" + statusText + "). Please check your interent connection and refresh the page."); 
								default: 
									const body = await response.text();
									if(body.length>0){
										var msg;
										try { //we have a body, check if it is a valid json object, some requests return json errors
											const data = JSON.parse(body);  
											console.log(data);   
											msg=data.title;     
										 } catch(err) {
											console.log(body);
										  }
										  if(msg) 
											throw new Error(msg);  
									}
									throw new Error("Request failed with a status of '" + statusText + "'"); 
							} 
						}
						else {
							return response;
						}
					}
					else
					{
						if(this.OnDiscoveryEndpointError)
							this.OnDiscoveryEndpointError(this.config.error);
					}
                } catch (err) {
                    console.log(err);
                    throw err;
                }
            }
        }
    }


